import { render, staticRenderFns } from "./Sub.vue?vue&type=template&id=7ace87a5&scoped=true&"
import script from "./Sub.vue?vue&type=script&lang=js&"
export * from "./Sub.vue?vue&type=script&lang=js&"
import style0 from "./Sub.vue?vue&type=style&index=0&id=7ace87a5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ace87a5",
  null
  
)

/* custom blocks */
import block0 from "./Sub.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports